import { ReactNode, useEffect, useMemo } from 'react';
import { useEventFlattedViewSelectedLegend } from 'src/components/Events/EventListing/useEventFlattedViewSelectedLegend';
import { useCatalogDataContext } from 'src/contexts/CatalogDataContext';
import { useContent } from 'src/contexts/ContentContext';
import { useMultiSelectionContext } from 'src/contexts/MultiSelectionContext';
import { useSearchDataContextWithCatalogFallback } from 'src/contexts/SearchDataContext';
import { ContentId } from 'src/utils/constants/contentId';

interface SetInventoryFlattenedViewSelectionCountLabelProps {
  children: ReactNode;
}

export const SetInventoryFlattenedViewSelectionCountLabel = ({
  children,
}: SetInventoryFlattenedViewSelectionCountLabelProps) => {
  const listingText = useContent(ContentId.Listing);
  const listingsText = useContent(ContentId.Listings);
  const { setSelectedCountLabel, setUsingCustomSelectedCountLabel } =
    useMultiSelectionContext();
  const { eventsTransformed } = useCatalogDataContext();
  const { totalItemsCount } = useSearchDataContextWithCatalogFallback();

  const catalogCount = useMemo(() => {
    let count = 0;
    (eventsTransformed ?? []).forEach((ev) => {
      count += ev.counts.listCnt ?? 0;
    });
    return count;
  }, [eventsTransformed]);

  const totalCount = totalItemsCount ?? catalogCount;

  useEffect(() => {
    setUsingCustomSelectedCountLabel(true);
  }, [setUsingCustomSelectedCountLabel]);

  const selectedLegend = useEventFlattedViewSelectedLegend({
    singleElementLabel: listingText,
    multipleElementsLabel: listingsText,
    totalCount,
  });

  useEffect(() => {
    setSelectedCountLabel(selectedLegend);
  }, [selectedLegend, setSelectedCountLabel]);

  return <>{children}</>;
};
